<template>
  <div class="content-wrapper">
    <div class="flex mb-4">
      <div class="lg:w-full w-full bg-grid-color h-12">
        <vs-card class="px-5 py-5">
          <section>
            <h1 class="pb-5">Event Info</h1>
			<div class="vx-row mb-6">
				<div class="vx-col sm:w-1/3 w-full">
					<span>Poster</span>
					<div style="font-size: 0.75rem; color: #aaa">
					Landscape artwork with recommended size of 1,200x630px (similar to
					that of Facebook's Post)
					</div>
				</div>
				<div class="vx-col sm:w-1/3 w-full">
					<div>
						<img
							v-if="form.poster != null && form.poster != '' "
							:src="form.poster"
							:width="imageWidth"
							:height="imageHeight"
						/>
						<div
							v-if="!form.poster"
							class="default-upload"
							style="width: 300px; height: 158px; background-color: #F5F5F5; border-radius: 8px; position: relative;"
						>
							<vs-button
								style="position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%);"
								color="dark"
								type="border"
								@click="chooseImage()"
							>
								<span>Upload</span>
							</vs-button>
						</div>
					</div>

				<!-- <vs-upload
					v-if="!event.poster || changeImage"
					:multiple="false"
					:automatic="true"
					:single-upload="true"
					:action="posterUploadUrl"
					:fileName="`file`"
					:limit="1"
					:data="posterData"
					:headers="posterUploadHeader"
					@on-success="successPosterUpload"
					@on-error="errorPosterUpload"
					accept="image/png, image/jpeg, image/jpg, image/webp"
				/> -->
					<div
						class="grid-button-upload"
						style="margin-top: 8px;
								display: grid;
								grid-template-columns: repeat(2, min-content);
								grid-gap: 10px;"
					>
						<!-- secondary / border  >> btn-->
						<vs-button
							v-if="form.poster"
							color="dark"
							type="border"
							icon="autorenew"
							style="display: flex"
							@click="chooseImage()"
						>
							<span>Change</span>
						</vs-button>
						<input
							id="file-upload-img"
							@change="onUploadImages()"
							type="file"
							ref="fileImage"
							:accept="acceptFile"
						>
						<vs-button
							v-if="form.poster"
							color="dark"
							type="border"
							icon="delete_forever"
							style="display: flex"
							@click="removeposter"
						>
							Remove
						</vs-button>
					</div>
				</div>
			</div>
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/3 w-full">
                <span>Name</span>
              </div>
              <div class="vx-col sm:w-2/3 w-full">
                <vs-input
                  v-validate="'required'"
                  name="name"
                  class="w-full"
                  placeholder="Startup Conference"
                  v-model="form.name"
                  :maxLength="60"
                />
                <span class="text-danger text-sm" v-show="errors.has('name')">
                  {{ splitError(errors.first("name"), ' name') }}
                </span>
              </div>
            </div>
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/3 w-full">
                <span>URL</span>
              </div>
              <div class="vx-col sm:w-2/3 w-full">
                <div style="display: flex; align-items: center;">
                  <span style="margin-right: 8px;">{{ domain }}</span>
                  <vs-input
                  v-validate="'required'"
                  class="w-full"
                  name="slug"
                  v-model="form.slug"
                  v-on:blur="validateSlug()"
                  onkeypress="return /^[\w-_.]*$/i.test(event.key)"
                  />
                </div>
                <span class="text-danger text-sm" v-show="errors.has('slug')">
                  {{ splitError(errors.first("slug"), ' slug') }}
                </span>
              </div>
            </div>
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/3 w-full">
                <span>Short Description</span>
              </div>
              <div class="vx-col sm:w-2/3 w-full mb-10">
                <ArticleEditor v-model="form.shortdesc" :config="{
                  plugins: ['blockcode'],
                  addbarAdd: ['text', 'card'],
                  css: '/article-editor/css/',
                  format: ['div', 'h1', 'h2', 'h3', 'ul', 'ol'],
                  align: {
                      'left': 'text-left',
                      'center': 'text-center',
                      'right': 'text-right',
                      'justify': 'text-justify'
                  }
                }"></ArticleEditor>
                <vs-textarea
                  style="display: none"
                  class="w-full"
                  v-model="form.shortdesc"
                />
              </div>
            </div>
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/3 w-full">
                <span>Date</span>
              </div>
              <div class="vx-col sm:w-2/3 w-full">
                <el-date-picker
                  v-validate="'required'"
                  name="daterange"
                  style="width: 100%"
                  value-format="yyyy-MM-dd HH:mm"
                  format="dd-MM-yyyy HH:mm"
                  v-model="form.daterange"
                  type="datetimerange"
                  range-separator="To"
                  start-placeholder="Start date"
                  end-placeholder="End date"
                ></el-date-picker>
                <span class="text-danger text-sm" v-show="errors.has('daterange')">
                  The date field is required
                </span>
              </div>
            </div>
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/3 w-full">
                <span>Time Zone</span>
              </div>
              <div class="vx-col sm:w-2/3 w-full">
                <el-select
                  style="width: 100%"
                  v-model="form.timezone"
                  filterable
                  placeholder="Select timezone"
                >
                  <el-option
                    v-for="item in timezones"
                    :key="item.key"
                    :label="item.value"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </div>
            </div>
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/3 w-full">
                <span>Venue</span>
              </div>
              <div class="vx-col sm:w-2/3 w-full">
                <vs-input
                  v-validate="'required'"
                  name="venue"
                  placeholder="Singapore EXPO, Atrium 4"
                  class="w-full"
                  v-model="form.venue"
                  onkeypress="return /^[\w-_. ]*$/i.test(event.key)"
                />
                <span class="text-danger text-sm" v-show="errors.has('venue')">
                  {{ splitError(errors.first("venue"), ' venue') }}
                </span>
              </div>
            </div>
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/3 w-full">
                <span>Type of Event</span>
              </div>
              <div class="vx-col sm:w-2/3 w-full">
                <ul class="demo-alignment">
                  <li>
                    <vs-radio v-model="form.mode" vs-value="standard"
                      >Offline</vs-radio
                    >
                  </li>
                  <li>
                    <vs-radio v-model="form.mode" vs-value="online"
                      >Online</vs-radio
                    >
                  </li>
                  <li>
                    <vs-radio v-model="form.mode" vs-value="conference"
                      >Conference</vs-radio
                    >
                  </li>
                  <!--
                  <li>
                    <vs-radio v-model="form.mode" vs-value="live"
                      >Live</vs-radio
                    >
                  </li>
                  -->
                  <!-- <li>
                <vs-radio v-model="form.mode" vs-value="single">Single Attendee Registration</vs-radio>
              </li>
              <li>
                <vs-radio v-model="form.mode" vs-value="onsite">On-site Registration</vs-radio>
                  </li>-->
                </ul>
              </div>
            </div>
            <div v-if="form.mode == 'online'" class="vx-row mb-6">
              <div class="vx-col sm:w-1/3 w-full">
                <span>Streaming Solution</span>
              </div>
              <div class="vx-col sm:w-2/3 w-full">
                <ul class="demo-alignment">
                  <li>
                    <vs-radio v-model="form.engine" vs-value="zoom"
                      >Zoom</vs-radio
                    >
                  </li>
                  <li>
                    <vs-radio v-model="form.engine" vs-value="ivs"
                      >Amazon IVS</vs-radio
                    >
                  </li>
                  <li>
                    <vs-radio v-model="form.engine" vs-value="vimeo"
                      >Vimeo</vs-radio
                    >
                  </li>
                  <li>
                    <vs-radio v-model="form.engine" vs-value="youtube"
                      >Youtube</vs-radio
                    >
                  </li>
                  <li>
                    <vs-radio v-model="form.engine" vs-value="facebook"
                      >Facebook</vs-radio
                    >
                  </li>
                  <li>
                    <vs-radio v-model="form.engine" vs-value="other"
                      >Other</vs-radio
                    >
                  </li>
                </ul>
              </div>
            </div>
            <!--
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/3 w-full">
                <span>Use Zoom to host the event</span>
              </div>
              <div class="vx-col sm:w-2/3 w-full">
                <vs-switch
                  :disabled="disableZoomToggle"
                  v-model="form.zoom_status"
                />
              </div>
            </div>
            -->
            <template v-if="form.engine == 'zoom' && form.mode == 'online'">
              <div class="vx-row mb-6">
                <div class="vx-col sm:w-1/3 w-full">
                  <span>Zoom Account</span>
                </div>
                <div class="vx-col sm:w-2/3 w-full">
                  <ul class="demo-alignment">
                    <li>
                      <vs-radio v-model="form.zoom_account_no" vs-value="acc_1"
                        >Account 1</vs-radio
                      >
                    </li>
                    <li>
                      <vs-radio v-model="form.zoom_account_no" vs-value="acc_2"
                        >Account 2</vs-radio
                      >
                    </li>
                  </ul>
                </div>
              </div>
              <div class="vx-row mb-6" v-if="form.zoom_status == 1">
                <div class="vx-col sm:w-1/3 w-full">
                  <span>Session Format</span>
                </div>
                <div class="vx-col sm:w-2/3 w-full">
                  <ul class="demo-alignment">
                    <li>
                      <vs-radio v-model="form.session_type" vs-value="webinar"
                        >Webinar</vs-radio
                      >
                    </li>
                    <li>
                      <vs-radio v-model="form.session_type" vs-value="meeting"
                        >Meeting</vs-radio
                      >
                    </li>
                  </ul>
                </div>
              </div>
            </template>
            <template v-if="form.engine == 'vimeo' && form.mode == 'online'">
              <div class="vx-row mb-6">
                <div class="vx-col sm:w-1/3 w-full">
                  <span>Live URL</span>
                </div>
                <div class="vx-col sm:w-2/3 w-full">
                  <vs-input
                    placeholder="Vimeo Live URL"
                    class="w-full"
                    v-model="form.live_url"
                  />
                </div>
              </div>
              <div class="vx-row mb-6">
                <div class="vx-col sm:w-1/3 w-full">
                  <span>Playback URL</span>
                </div>
                <div class="vx-col sm:w-2/3 w-full">
                  <vs-input
                    placeholder="Leave this field blank if it same Live URL"
                    class="w-full"
                    v-model="form.playback_url"
                  />
                </div>
              </div>
            </template>
            <template v-if="form.engine == 'youtube' && form.mode == 'online'">
              <div class="vx-row mb-6">
                <div class="vx-col sm:w-1/3 w-full">
                  <span>Live URL</span>
                </div>
                <div class="vx-col sm:w-2/3 w-full">
                  <vs-input
                    placeholder="Youtube Live URL"
                    class="w-full"
                    v-model="form.live_url"
                  />
                </div>
              </div>
              <div class="vx-row mb-6">
                <div class="vx-col sm:w-1/3 w-full">
                  <span>Playback URL</span>
                </div>
                <div class="vx-col sm:w-2/3 w-full">
                  <vs-input
                    placeholder="Leave this field blank if it same Live URL"
                    class="w-full"
                    v-model="form.playback_url"
                  />
                </div>
              </div>
            </template>
            <template v-if="form.engine == 'facebook' && form.mode == 'online'">
              <div class="vx-row mb-6">
                <div class="vx-col sm:w-1/3 w-full">
                  <span>Live URL</span>
                </div>
                <div class="vx-col sm:w-2/3 w-full">
                  <vs-input
                    placeholder="Facebook Live URL"
                    class="w-full"
                    v-model="form.live_url"
                  />
                </div>
              </div>
              <div class="vx-row mb-6">
                <div class="vx-col sm:w-1/3 w-full">
                  <span>Playback URL</span>
                </div>
                <div class="vx-col sm:w-2/3 w-full">
                  <vs-input
                    placeholder="Leave this field blank if it same Live URL"
                    class="w-full"
                    v-model="form.playback_url"
                  />
                </div>
              </div>
            </template>

            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/3 w-full">
                <span>Is this a Free event?</span>
              </div>
              <div class="vx-col sm:w-2/3 w-full">
                <ul class="demo-alignment">

                  <li>
                    <vs-radio
                      v-model="form.freeevent"
                      vs-name="radios-freeevent"
                      :vs-value="1"
                      >Yes</vs-radio
                    >
                  </li>
                  <li>
                    <vs-radio
                      v-model="form.freeevent"
                      vs-name="radios-freeevent"
                      :vs-value="0"
                      >No</vs-radio
                    >
                  </li>
                </ul>
              </div>
            </div>

            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/3 w-full">
                <span>Privacy</span>
              </div>
              <div class="vx-col sm:w-2/3 w-full">
                <ul>
                  <li class="my-2">
                    <vs-radio v-model="form.privacy" vs-value="public"
                      >Public
                      <span style="font-size:0.75rem; color:#aaa;"
                        >- Anyone with the link can see the registration
                        page</span
                      ></vs-radio
                    >
                  </li>
                  <li class="my-2">
                    <vs-radio v-model="form.privacy" vs-value="unlisted"
                      >Unlisted
                      <span style="font-size:0.75rem; color:#aaa;"
                        >- The registration page will be hidden</span
                      ></vs-radio
                    >
                  </li>
                  <li class="my-2">
                    <vs-radio v-model="form.privacy" vs-value="invite-only"
                      >Invite Only
                      <span style="font-size:0.75rem; color:#aaa;"
                        >- Only those with invite code will be able to see the
                        registration page</span
                      ></vs-radio
                    >
                  </li>
                </ul>
              </div>
            </div>

            <div class="vx-row mb-6" v-if="form.privacy == 'invite-only'">
              <div class="vx-col sm:w-1/3 w-full">
                <span>Invite Code</span>
              </div>
              <div class="vx-col sm:w-2/3 w-full">
                <vs-input
                  class="w-full"
                  placeholder="Enter Code"
                  v-model="form.private_token"
                  onkeypress="return /^[\w-_.]*$/i.test(event.key)"
                />
              </div>
            </div>

            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/3 w-full">
                <span>Registration Period</span>
              </div>
              <div class="vx-col sm:w-2/3 w-full">
                <el-date-picker
                  style="width: 100%"
                  type="datetimerange"
                  value-format="yyyy-MM-dd HH:mm"
                  format="dd-MM-yyyy HH:mm"
                  v-model="form.selldaterange"
                  range-separator="To"
                  start-placeholder="Start date"
                  end-placeholder="End date"
                ></el-date-picker>
              </div>
            </div>
          </section>

          <template v-if="form.freeevent == 0">
            <hr />
            <section>
              <h1 class="py-5">Currency Settings</h1>
              <div class="vx-row mb-6">
                <div class="vx-col sm:w-1/3 w-full">
                  <span>Currency</span>
                  <div style="font-size:0.75rem; color:#aaa;">
                    The ticket currency to be displayed
                  </div>
                </div>
                <div class="vx-col sm:w-2/3 w-full">
                  <b-form-select
                    v-model="currencyForm.currency"
                    :options="currencyList"
                  ></b-form-select>
                  <!--
                  <vs-input placeholder="Eg. USD" class="w-full" v-model="currencyForm.currency" />
                  -->
                </div>
              </div>
              <div class="vx-row mb-6">
                <div class="vx-col sm:w-1/3 w-full">
                  <span>Has Reference Currency?</span>
                  <div style="font-size:0.75rem; color:#aaa;">
                    Other currency to be shown as comparison
                  </div>
                </div>
                <div class="vx-col sm:w-2/3 w-full">
                  <ul class="demo-alignment">
                    <li>
                      <vs-radio
                        v-model="currencyForm.hasReference"
                        :vs-value="false"
                        >No</vs-radio
                      >
                    </li>
                    <li>
                      <vs-radio
                        v-model="currencyForm.hasReference"
                        :vs-value="true"
                        >Yes</vs-radio
                      >
                    </li>
                  </ul>
                </div>
              </div>
              <template v-if="currencyForm.hasReference">
                <div class="vx-row mb-6">
                  <div class="vx-col sm:w-1/3 w-full">
                    <span>Reference Currency</span>
                  </div>
                  <div class="vx-col sm:w-2/3 w-full">
                    <b-form-select
                      v-model="currencyForm.altcurrencycode"
                      :options="currencyList"
                    ></b-form-select>
                  </div>
                </div>
                <div class="vx-row mb-6">
                  <div class="vx-col sm:w-1/3 w-full">
                    <span>Exchange Rate</span>
                  </div>
                  <div class="vx-col sm:w-2/3 w-full">
                    <vs-input
                      v-validate="'decimal:4'"
                      name="altcurrencyrate"
                      placeholder="32.10"
                      class="w-full"
                      v-model="currencyForm.altcurrencyrate"
                      onkeypress="return /^[0-9]*\.?[0-9]*$/i.test(event.key)"
                    />
                    <span
                      class="text-danger text-sm"
                      v-show="errors.has('altcurrencyrate')"
                      >{{ errors.first("altcurrencyrate") }}</span
                    >
                  </div>
                </div>
              </template>
            </section>
          </template>
          <hr />
          <section>
            <h1 class="py-5">Ticket Settings</h1>
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/3 w-full">
                <span>Title</span>
              </div>
              <div class="vx-col sm:w-2/3 w-full">
                <vs-input
                  v-validate="{required: true}"
                  name="titleTicket"
                  placeholder="General"
                  class="w-full"
                  v-model="ticketForm.title"
                  onkeypress="return /^[\w -_./\#$%*@&!()=]*$/i.test(event.key)"
                />
                <span
                  class="text-danger text-sm"
                  v-show="errors.has('titleTicket')"
                >
                  {{ splitError(errors.first('titleTicket'), 'titleTicket') }}
                </span>
              </div>
            </div>
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/3 w-full">
                <span>Slug</span>
              </div>
              <div class="vx-col sm:w-2/3 w-full">
                <vs-input
                  v-validate="{required: true}"
                  name="slugTicket"
                  class="w-full"
                  v-model="ticketForm.slug"
                  v-on:keyup="validateTicketSlug()"
                  onkeypress="return /^[\w-_.]*$/i.test(event.key)"
                />
                <span
                  class="text-danger text-sm"
                  v-show="errors.has('slugTicket')"
                >
                  {{ splitError(errors.first('slugTicket'), 'slugTicket') }}
                </span>
              </div>
            </div>
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/3 w-full">
                <span>Short Description</span>
              </div>
              <div class="vx-col sm:w-2/3 w-full">
                <!-- mb-10 -->
                <!-- <quill-editor
                  class="editor"
                  v-model="ticketForm.shortdesc"
                  :options="editor2Option"
                  @blur="onEditorBlur($event)"
                  @focus="onEditorFocus($event)"
                  @ready="onEditorReady($event)"
                >
                  <div id="toolbar-2" slot="toolbar">
                    # Add a bold button
                    <button class="ql-bold">Bold</button>
                    <button class="ql-italic">Italic</button>
                    # Add font size dropdown
                    <select class="ql-size">
                      <option value="small"></option>
                      # Note a missing, thus falsy value, is used to reset to default
                      <option selected></option>
                      <option value="large"></option>
                      <option value="huge"></option>
                    </select>
                    <select class="ql-font">
                      <option selected="selected"></option>
                      <option value="serif"></option>
                      <option value="monospace"></option>
                    </select>
                    # Add subscript and superscript buttons
                    <button class="ql-script" value="sub"></button>
                    <button class="ql-script" value="super"></button>
                  </div>
                </quill-editor> -->
                <vs-textarea
                  rows="5"
                  style="width: 100%"
                  v-model="ticketForm.shortdesc"
                  label-placeholder=" "
                />
              </div>
            </div>
            <div class="vx-row mb-6" v-if="form.freeevent == 0">
              <div class="vx-col sm:w-1/3 w-full">
                <span>Full Price</span>
              </div>
              <div class="vx-col sm:w-2/3 w-full">
                <vs-input
                  :disabled="form.freeevent == 1"
                  v-validate="{ required: true, decimal: '2', min_value: 1 }"
                  name="fullprice"
                  type="tel"
                  class="w-full"
                  v-model="ticketForm.fullprice"
                  onkeypress="return /^[0-9]*\.?[0-9]*$/i.test(event.key)"
                />
                <span class="text-warning text-sm" v-show="form.freeevent == 1"
                  >Cannot set ticket price is event if free</span
                >
                <span
                  class="text-danger text-sm"
                  v-show="errors.has('fullprice')"
                >
                  {{ splitError(errors.first("fullprice"), ' fullprice') }}
                </span>
              </div>
            </div>
            <div class="vx-row mb-6" v-if="form.freeevent == 0">
              <div class="vx-col sm:w-1/3 w-full">
                <span>Selling Price</span>
                <div style="font-size:0.75rem; color:#aaa;">
                  If price is lower than full price, it will be shown as a
                  discounted price
                </div>
              </div>
              <div class="vx-col sm:w-2/3 w-full">
                <vs-input
                  :disabled="form.freeevent == 1"
                  v-validate="{
                    required: true,
                    decimal: '2',
                    max_value: ticketForm.fullprice,
                    min_value: 1
                  }"
                  name="sellingprice"
                  type="tel"
                  class="w-full"
                  v-model="ticketForm.price"
                  onkeypress="return /^[0-9]*\.?[0-9]*$/i.test(event.key)"
                />
                <span class="text-warning text-sm" v-show="form.freeevent == 1"
                  >Cannot set ticket price is event if free</span
                >
                <span
                  class="text-danger text-sm"
                  v-show="errors.has('sellingprice')"
                >
                  {{ splitError(errors.first("sellingprice"), ' sellingprice') }}
                </span>
              </div>
            </div>
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/3 w-full">
                <span>Registration Period</span>
              </div>
              <div class="vx-col sm:w-2/3 w-full">
                <el-date-picker
                  v-validate="'required'"
                  name="selldaterange"
                  style="width: 100%"
                  type="datetimerange"
                  value-format="yyyy-MM-dd HH:mm"
                  format="dd-MM-yyyy HH:mm"
                  v-model="ticketForm.selldaterange"
                  range-separator="To"
                  start-placeholder="Start date"
                  end-placeholder="End date"
                ></el-date-picker>
                <span class="text-danger text-sm" v-show="errors.has('selldaterange')">
                  The Registration Period field is required
                </span>
              </div>
            </div>
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/3 w-full">
                <span>Quantity</span>
              </div>
              <div class="vx-col sm:w-2/3 w-full">
                <vs-input
                  v-validate="{
                    required: true,
                    regex: '^([0-9]+)$',
                    max_value: merchant.attendee_per_event? merchant.attendee_per_event : 9999999,
                    min_value:1
                    }"
                  type="tel"
                  class="w-full"
                  name="qty"
                  v-model="ticketForm.qty"
                  v-on:blur="validateQuantity()"
                  onkeypress="return /^[0-9]*$/i.test(event.key)"
                />
                <span
                  class="text-danger text-sm"
                  v-show="errors.has('qty')"
                >
                  {{ splitError(errors.first("qty"), ' qty') }}
                </span>
              </div>
            </div>
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/3 w-full">
                <span>Note for Attendee</span>
                <div style="font-size:0.75rem; color:#aaa;">
                  This text will be shown in the ticket email received by
                  attendees which is additional information about the event
                </div>
              </div>
              <div class="vx-col sm:w-2/3 w-full">
                <vs-textarea
                  class="w-full"
                  placeholder=""
                  v-model="ticketForm.ticket_note"
                />
              </div>
            </div>
            <!--
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/3 w-full">
                <span>Quantity per Pack</span>
              </div>
              <div class="vx-col sm:w-2/3 w-full">
                <vs-input
                  type="tel"
                  v-validate="{required:true, regex: '^([0-9]+)$' }"
                  name="requiredqty"
                  class="w-full"
                  v-model="ticketForm.requiredqty"
                />
                <span
                  class="text-danger text-sm"
                  v-show="errors.has('requiredqty')"
                >{{ errors.first('requiredqty') }}</span>
              </div>
            </div>
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/3 w-full">
                <span>Minimum Quantity</span>
              </div>
              <div class="vx-col sm:w-2/3 w-full">
                <vs-input
                  type="tel"
                  v-validate="{required:true, regex: '^([0-9]+)$' }"
                  name="minqty"
                  class="w-full"
                  v-model="ticketForm.minqty"
                />
                <span
                  class="text-danger text-sm"
                  v-show="errors.has('minqty')"
                >{{ errors.first('minqty') }}</span>
              </div>
            </div>
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/3 w-full">
                <span>Maximum Quantity</span>
              </div>
              <div class="vx-col sm:w-2/3 w-full">
                <vs-input
                  type="tel"
                  v-validate="{required:true, regex: '^([0-9]+)$', min_value:ticketForm.minqty }"
                  name="maxqty"
                  class="w-full"
                  v-model="ticketForm.maxqty"
                />
                <span
                  class="text-danger text-sm"
                  v-show="errors.has('maxqty')"
                >{{ errors.first('maxqty') }}</span>
              </div>
            </div>
            -->
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/3 w-full">
                <span>Visibility</span>
              </div>
              <div class="vx-col sm:w-2/3 w-full">
                <ul class="demo-alignment">
                  <li>
                    <vs-radio
                      v-model="ticketForm.publish_status"
                      name="ticket-status"
                      vs-value="1"
                      >Show</vs-radio
                    >
                  </li>
                  <li>
                    <vs-radio
                      v-model="ticketForm.publish_status"
                      name="ticket-status"
                      vs-value="0"
                      >Hide</vs-radio
                    >
                  </li>
                </ul>
              </div>
            </div>
            <hr />

            <!--
            <section>
              <h1 class="py-5">Chat Settings</h1>
              <div class="vx-row mb-6">
                <div class="vx-col sm:w-1/3 w-full">
                  <span>Arena Chat Session ID</span>
                </div>
                <div class="vx-col sm:w-2/3 w-full">
                  <vs-input class="w-full" v-model="form.chat_id" />
                </div>
              </div>
            </section>
            -->

            <div class="vx-row mb-6" v-if="form.mode == 'live'">
              <div class="vx-col sm:w-1/3 w-full">
                <span>Concurrent Session</span>
              </div>
              <div class="vx-col sm:w-2/3 w-full">
                <b-form-select
                  v-model="ticketForm.live_concurrent_session"
                  :options="concurrentList"
                ></b-form-select>
              </div>
            </div>
            <!--
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/3 w-full">
                <span>Sorting Weight</span>
              </div>
              <div class="vx-col sm:w-2/3 w-full">
                <vs-input type="tel" class="w-full" v-model="ticketForm.weight" />
              </div>
            </div>
            -->
          </section>
          <div class="vx-row pt-5">
            <div class="vx-col sm:w-2/3 w-full ml-auto">
              <vs-button
                :disabled="!valid"
                class="mr-3 mb-2"
                @click.prevent="validateForm"
                >Create an Event</vs-button
              >
            </div>
          </div>
        </vs-card>
      </div>
    </div>
  </div>
</template>

<script>
import { Validator } from "vee-validate";

import Service from "@/services";

import moment from "moment";
import { mapState } from "vuex";
import { timezones } from "@/utils/Timezones";
import { currencyList } from "@/utils/Constants";
import ArticleEditor from "@/components/ArticleEditor.vue";
import services from '../../../services';

const dict = {
  form: {
    name: {
      required: "Please enter an event name"
    },
    slug: {
      required: "Please enter your last name",
      alpha: "Your last name may only contain alphabetic characters"
    }
  }
};

// register custom messages
Validator.localize("en", dict);

export default {
  components: {ArticleEditor},
  data: () => ({
    isClone: false,
    timezones: timezones,
    valid: true,
    editorOption: {
      modules: {
        toolbar: "#toolbar"
      },
      placeholder: ""
    },
    editor2Option: {
      modules: {
        toolbar: "#toolbar-2"
      },
      placeholder: ""
    },
    merchant: {},
    form: {
      s: null,
      name: "",
      slug: "",
      daterange: [
        moment().format("YYYY-MM-DD HH:mm"),
        moment().format("YYYY-MM-DD HH:mm")
      ],
      selldaterange: [
        moment().format("YYYY-MM-DD HH:mm"),
        moment().format("YYYY-MM-DD HH:mm")
      ],
      shortdesc: "",
      timezone: "Asia/Bangkok",
      venue: "",
      poster: "",
      zoom_status: 1,
      zoom_account_no: "acc_2",
      session_type: "webinar",
      mode: "online",
      engine: "zoom",
      freeevent: 0,
      privacy: "public",
      private_token: ""
    },
    currencyList: [],
    concurrentList: [
      { value: 0, text: "Unlimited" },
      { value: 1, text: "1" },
      { value: 2, text: "2" },
      { value: 3, text: "3" },
      { value: 4, text: "4" },
      { value: 5, text: "5" }
    ],
    currencyForm: {
      currency: "THB",
      hasReference: false,
      altcurrencycode: "USD",
      altcurrencyrate: null
    },
    ticketForm: {
      title: "",
      slug: "",
      shortdesc: "",
      price: 0,
      fullprice: 0,
      selldaterange: [
        moment().format("YYYY-MM-DD HH:mm"),
        moment().format("YYYY-MM-DD HH:mm")
      ],
      ticket_note: "",
      qty: null,
      requiredqty: null,
      minqty: null,
      maxqty: null,
      publish_status: 1,
      weight: 0,
      live_concurrent_session: 0
    },
    disableZoomToggle: false,
    remain_quantity: 0,
    is_verify: '',
    current_name: '',
	acceptFile: [
		'image/png',
		'image/jpeg',
		'image/jpg',
		'image/webp',
	],
	posterUpdate: null,
	imageWidth: 0,
	imageHeight: 0,
	domain: null
  }),
  computed: {
    ...mapState({
      s: state => {
        return state.Utility.s;
      },
      e: state => {
        return state.Utility.e;
      }
    })
  },
  created() {
    this.timezones = Object.keys(this.timezones).map(item => {
      return { key: item, value: item };
    });
    this.currencyList = Object.keys(currencyList);
    if (this.$route.query.clone) {
      this.isClone = true;
      Service.Event.get(this.$route.query.clone)
        .then(res => {
          this.merchant = res.data.event.merchant;
          this.form = {
            s: res.data.event.merchant.s,
            name: res.data.event.pro_name,
            slug: res.data.event.slug,
            daterange: [
              moment().format("YYYY-MM-DD HH:mm"),
              moment().format("YYYY-MM-DD HH:mm")
            ],
            selldaterange: [
              moment().format("YYYY-MM-DD HH:mm"),
              moment().format("YYYY-MM-DD HH:mm")
            ],
            shortdesc: res.data.event.pro_shortdesc,
            timezone: res.data.event.timezone,
            venue: res.data.event.venue,
            poster: "",
            zoom_status: res.data.event.zoom_status,
            mode: "online",
            freeevent: res.data.event.freeevent,
            privacy: res.data.event.privacy,
            private_token: ""
          };
        })
        .catch(e => {
          /* this.$router.push("/pages/error-404").catch(() => {}); */
        });
    } else {
		this.form.s = this.s;
		const folder = this.$route.query.e
		Service.Event.get(folder)
			.then(res => {
				this.domain = `https://${res.data.event.merchant.domain}/`
        this.merchant = res.data.event.merchant;
			})
			.catch(() => {})
    }
  },
  watch: {
    "form.name": function(newVal, oldVal) {
      var slugify = require("slugify");
      this.form.slug = slugify(newVal, {
        replacement: "-", // replace spaces with replacement character, defaults to `-`
        remove: /[*#+~%^&*.()๋ัฤ็ฺ๋?ฦ๐ํ๊ฯ,ๆำๅกขฃคฅฆงจฉชซฌญฎฏฐฑฒณดตถทธนบปผฝพฟภมยรลวศษสอหฬฮะาิีุูึ์ ืแโใไ๑๒๓๔ู฿๕๖๗๘๙่เ้'"!:@=]/g, // remove characters that match regex, defaults to `undefined`
        lower: true, // convert to lower case, defaults to `false`
        strict: false // strip special characters except replacement, defaults to `false`
      });

      if (this.form.slug.match(/(\w+)/g).length > 5) {
        var words = this.form.slug.split("-");
        this.form.slug =
          words[0] +
          "-" +
          words[1] +
          "-" +
          words[2] +
          "-" +
          words[3] +
          "-" +
          words[4];
      }
    },
    "form.mode": function(newVal, oldVal) {
      if (newVal == "online") {
        this.form.zoom_status = 1;
        this.disableZoomToggle = false;
      } else {
        this.form.zoom_status = 0;
        this.disableZoomToggle = true;
      }
    },
    "form.freeevent": function(newVal, oldVal) {
      if (newVal == 1) {
        this.ticketForm.price = 0;
        this.ticketForm.fullprice = 0;
        this.currencyForm.currency = null;
        this.currencyForm.altcurrencycode = null;
        this.currencyForm.altcurrencyrate = null;
      }
    },
    "form.privacy": function(newVal, oldVal) {
      if (newVal == "invite-only") {
      }
    },
    "ticketForm.title": function(newVal, oldVal) {
      var slugify = require("slugify");
      this.ticketForm.slug = slugify(newVal, {
        replacement: "-", // replace spaces with replacement character, defaults to `-`
        remove: /[*#+~%^&*.()๋ัฤ็ฺ๋?ฦ๐ํ๊ฯ,ๆำๅกขฃคฅฆงจฉชซฌญฎฏฐฑฒณดตถทธนบปผฝพฟภมยรลวศษสอหฬฮะาิีุูึ์ ืแโใไ๑๒๓๔ู฿๕๖๗๘๙่เ้'"!:@=]/g, // remove characters that match regex, defaults to `undefined`
        lower: true, // convert to lower case, defaults to `false`
        strict: false // strip special characters except replacement, defaults to `false`
      });

      if (this.ticketForm.slug.match(/(\w+)/g).length > 5) {
        var words = this.ticketForm.slug.split("-");
        this.ticketForm.slug =
          words[0] +
          "-" +
          words[1] +
          "-" +
          words[2] +
          "-" +
          words[3] +
          "-" +
          words[4];
      }
    },
    "current_name" (val) {
      if (val === this.form.name) {
        this.current_name = val
        this.is_check = true
      }
      else {
        this.is_check = false
      }
    },
  },
  methods: {
    splitError(val, word) {
      if (!val) {
                return
            }
            else {
                const data = val.split(word)
                return data[0] + data[1]
            }
    },
	setImageSize () {
      let posterimage = document.querySelector('img')
      let w = posterimage.naturalWidth;
      let h = posterimage.naturalHeight;
      this.imageHeight = h
      this.imageWidth = w

      if (w > h) {
        this.imageWidth = 300
        this.imageHeight = 'auto'
      }
      else {
        this.imageHeight = 300
        this.imageWidth = 'auto'
      }
    },
    replaceAll(str, find, replace) {
      return str.replace(new RegExp(find, "g"), replace);
    },
    validateForm() {
      this.form.shortdesc = this.replaceAll(this.form.shortdesc, "<p", "<div");
      this.form.shortdesc = this.replaceAll(
        this.form.shortdesc,
        "<\/p>",
        "<\/div>"
      );

      this.ticketForm.shortdesc = this.replaceAll(
        this.ticketForm.shortdesc,
        "<p",
        "<div"
      );
      this.ticketForm.shortdesc = this.replaceAll(
        this.ticketForm.shortdesc,
        "<\/p>",
        "<\/div>"
      );

      this.$validator.validateAll().then(result => {
        if (result) {
          // if form have no errors
          this.submit();
        } else {
          // form have errors
        }
      });
    },
    validateTicketSlug() {
      var slugify = require("slugify");
      this.ticketForm.slug = slugify(this.ticketForm.slug, {
        replacement: "-", // replace spaces with replacement character, defaults to `-`
        remove: /[*#+~%^&*.()๋ัฤ็ฺ๋?ฦ๐ํ๊ฯ,ๆำๅกขฃคฅฆงจฉชซฌญฎฏฐฑฒณดตถทธนบปผฝพฟภมยรลวศษสอหฬฮะาิีุูึ์ ืแโใไ๑๒๓๔ู฿๕๖๗๘๙่เ้'"!:@=]/g, // remove characters that match regex, defaults to `undefined`
        lower: true, // convert to lower case, defaults to `false`
        strict: false // strip special characters except replacement, defaults to `false`
      });

      if (this.ticketForm.slug.match(/(\w+)/g).length > 5) {
        var words = this.ticketForm.slug.split("-");
        this.ticketForm.slug =
          words[0] +
          "-" +
          words[1] +
          "-" +
          words[2] +
          "-" +
          words[3] +
          "-" +
          words[4];
      }
    },
    validateSlug() {
      if (this.form.slug != '') {
        this.$vs.loading();
        var slugify = require("slugify");
        this.form.slug = slugify(this.form.slug, {
          replacement: "-", // replace spaces with replacement character, defaults to `-`
          remove: /[*#+~%^&*.()๋ัฤ็ฺ๋?ฦ๐ํ๊ฯ,ๆำๅกขฃคฅฆงจฉชซฌญฎฏฐฑฒณดตถทธนบปผฝพฟภมยรลวศษสอหฬฮะาิีุูึ์ ืแโใไ๑๒๓๔ู฿๕๖๗๘๙่เ้'"!:@=]/g, // remove characters that match regex, defaults to `undefined`
          lower: true, // convert to lower case, defaults to `false`
          strict: false // strip special characters except replacement, defaults to `false`
        });

        if (this.form.slug.match(/(\w+)/g).length > 5) {
          var words = this.form.slug.split("-");
          this.form.slug =
            words[0] +
            "-" +
            words[1] +
            "-" +
            words[2] +
            "-" +
            words[3] +
            "-" +
            words[4];
        }

        Service.Event.search(this.form.slug).then(res => {
          if (res.data.results.length > 0) {
            this.$vs.notify({
              title: "Oops!",
              text: "ERROR : This slug already used by others.",
              color: "danger",
              fixed: true
            });
          } else {
          }
          this.$vs.loading.close();
        });
      }
    },
    submit() {
    //   if (this.is_verify === true) {
        let data = {
          e: this.$route.query.e,
          s: this.$route.query.s
        };

        let params = Object.keys(data)
          .map(key => key + "=" + data[key])
          .join("&");

        if (this.form.privacy == "invite-only") {
          if (this.form.private_token == "") {
            this.$vs.notify({
              title: "Oops!",
              text: "Invite code is required",
              color: "danger"
            });
            return;
          }
        }

        this.$vs.loading();

		const newData = {
          ...this.form,
          ...this.currencyForm,
        //   ticket: this.ticketForm
        };

    if (!newData.hasReference) {
      newData.altcurrencycode = ''
      newData.altcurrencyrate = ''
    }

		// const formTicket = new FormData();
		// const ticketkeyForm = Object.key(this.ticketForm);
		// for (let index = 0; index < ticketkeyForm.length; index++) {
		// 	const key = datakeyForm[index];
		// 	const value = newData[key];
		// 	formTicket.append(key, value);
		// }

		const formEventData = new FormData();
		const datakeyForm = Object.keys(newData);
		for (let index = 0; index < datakeyForm.length; index++) {
			const key = datakeyForm[index];
			const value = newData[key];
			formEventData.append(key, value);
		}
		formEventData.set('poster', this.posterUpdate)
		// formEventData.set('ticket', this.ticketForm)
		const ticketkeyForm = Object.keys(this.ticketForm);
		for (let index = 0; index < ticketkeyForm.length; index++) {
			const key = ticketkeyForm[index];
			const value = this.ticketForm[key];
			formEventData.append(`ticket[${key}]`, value);
		}

		formEventData.delete('daterange')
		formEventData.delete('selldaterange')
		formEventData.delete('ticket[selldaterange]')

		formEventData.set('daterange[0]', this.form.daterange[0])
		formEventData.set('daterange[1]', this.form.daterange[1])
    formEventData.set('datetime', this.form.daterange[0])
    formEventData.set('datetime_start', this.form.daterange[0])
    formEventData.set('datetime_end', this.form.daterange[1])
		formEventData.set('selldaterange[0]', this.form.selldaterange[0])
		formEventData.set('selldaterange[1]', this.form.selldaterange[1])
		formEventData.set('ticket[selldaterange][0]', this.ticketForm.selldaterange[0])
		formEventData.set('ticket[selldaterange][1]', this.ticketForm.selldaterange[1])

		// this.form.daterange = [this.daterange.selldaterange[0], this.daterange.selldaterange[1]]
		// this.form.selldaterange = [this.form.selldaterange[0], this.form.selldaterange[1]]
		// this.ticketForm.selldaterange = [this.ticketForm.selldaterange[0], this.ticketForm.selldaterange[1]]



        Service.Event.create(formEventData)
        // Service.Event.create(newData)
        .then(res => {
          if (res.success) {
			// const eventName = {
			// 	e: res.data.event.pro_name
			// };
			// Service.Event.updateImage(formEventData, eventName)
			// 	.then(() => {
			// 	})
			// 	.catch(() => {})

			this.$vs.notify({
				title: "Success",
				text: "Update complete.",
				color: "success"
			});

            // this.$router.push("/events");
          }
          this.$vs.loading.close();
          this.$router.push("/events");
        })
        .catch(err => {
          this.$vs.notify({
            title: "Oops!",
            text: "ERROR : " + err.error,
            color: "danger"
          });
          this.$vs.loading.close();
        });
    //   }
    //   else {
    //     this.$vs.notify({
    //       title: "Oops!",
    //       text: "Please verify your event name",
    //       color: "danger"
    //     });
    //   }
    },
    onEditorBlur(quill) {
      //console.log("editor blur!", quill);
    },
    onEditorFocus(quill) {
      //console.log("editor focus!", quill);
    },
    onEditorReady(quill) {
      //console.log("editor ready!", quill);
    },
    onEditorChange({ quill, html, text }) {
      //console.log("editor change!", quill, html, text);
      //this.content = html;
    },

    validateQuantity() {
      /* free event, max = 100 */
      if (this.form.freeevent) {
        if (parseInt(this.ticketForm.qty) > 100) {
          this.ticketForm.qty = 100;
          alert("Limit Quantity for free event is 100.");
        }
      }
      return;
    },
    checkName(val) {
      const data = {
        name : val
      }
      Service.Event.checkEventName(data)
        .then(res => {
          if (!res.is_verify) {
            this.is_check = false
            this.is_verify = res.is_verify

          }
          else {
            this.is_check = true
            this.is_verify = res.is_verify
            this.current_name = val
          }
        })
        .catch(() => {})
    },
	removeposter() {
		this.form.poster = null
	},
    chooseImage() {
      document.getElementById("file-upload-img").click()
    },
    onUploadImages() {
		this.posterUpdate = this.$refs.fileImage.files[0]
		this.form.poster = this.$refs.fileImage.files[0]
		const reader = new FileReader()
		reader.onloadend = async() => {
			this.form.poster = reader.result
			// this.posterUpdate = reader.result
			this.setImageSize()
		}
		reader.readAsDataURL(this.$refs.fileImage.files[0])
		this.$refs.fileImage.value = null
    },

  }
};
</script>
<style lang="scss" scoped>
.editor {
  height: 10rem;
  margin-bottom: 0px;
}
.custom-section {
  display: grid;
  align-items: center;
  grid-template-columns: auto max-content;
  grid-gap: 8px;
  &.re-verify {
    grid-template-columns: auto max-content max-content;
    align-items: center;
    &:deep i {
      display: flex;
      align-items: center;
    }
  }
  & .custom-btn-check{
    margin: 0 !important;
  }
}

input[type="file"] {
	display: none !important;
}
</style>
